import React, { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import PlanMyTripModal from "@/components/PlanMyTripModal";
import AITripPlanner from "@/components/AITripPlanner";
import ScrollToTop from "@/components/ScrollToTop";

const LayoutCtx = createContext(null);
export const useLayout = () => useContext(LayoutCtx);

export default function Layout() {
  const [planOpen, setPlanOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const [planInitial, setPlanInitial] = useState({});

  const openPlan = () => {
  window.open(
    `https://wa.me/9622469097?text=${encodeURIComponent(
      "Hi Travwave, I'd like to plan my trip."
    )}`,
    "_blank"
  );
};
  const openAI = () => setAiOpen(true);

  return (
    <LayoutCtx.Provider value={{ openPlan, openAI }}>
      <ScrollToTop />
      <div className="bg-[#F8F9FB] min-h-screen flex flex-col">
        <Navbar onPlanTrip={() => openPlan()} />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <FloatingActions onAI={openAI} onPlanTrip={() => openPlan()} />
        <PlanMyTripModal open={planOpen} onClose={() => setPlanOpen(false)} initial={planInitial} />
        <AITripPlanner open={aiOpen} onClose={() => setAiOpen(false)} />
      </div>
    </LayoutCtx.Provider>
  );
}
